import React from 'react';
import PropTypes from 'prop-types';

import {useLocation} from 'react-router-dom';

import {dispatch, connect} from 'utils/state_manager';

import {Drawer, Box} from 'views/components';
import {AppBar, Toolbar, IconButton} from 'views/components';
import {Menu as MenuIcon} from 'views/icons';

import NavbarLogo from './navbar_top/NavbarLogo';
import NavbarServices from './navbar_services/NavbarServices';
import NavbarUser from './navbar_bottom/NavbarUser';

const NavBar = (props) => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const services = props.services;

  const location = useLocation();

  React.useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  return (
    <>
      <AppBar position="static" >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            sx={{mr: 2}}
            onClick={() => setDrawerOpen(true)}
          >
            <MenuIcon />
          </IconButton>
          <NavbarLogo />
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          'width': 240,
          'flexShrink': 0,
          '& .MuiDrawer-paper': {
            width: 240,
            boxSizing: 'border-box',
          },
        }}
        PaperProps={{
          sx: {
            backgroundColor: 'navbar.main',
          },
        }}
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        anchor="left"
      >
        <Box sx={{
          pt: 2,
          pb: 1,
          px: 2,
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
        >
          <NavbarLogo />
        </Box>
        <Box sx={{
          px: 2,
        }}
        >
          <NavbarServices
            services={Object.values(services)}
            onClick={() => setDrawerOpen(false)}
          />
        </Box>
        <Box sx={{
          mt: 'auto',
          px: 2,
          pb: 2,
        }}
        >
          <NavbarUser />
        </Box>
      </Drawer>
    </>
  );
};

NavBar.propTypes = {
  services: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavBar));
